import { Alert, Button, Grid, Link, Stack, Typography } from '@mui/material'
import { contactPageUrl, privacyPageUrl } from '../constants/constants'
import { useLocation, useNavigate } from 'react-router-dom'

import { Activity } from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import HolloidSvg from '../components/common/HolloidSvg'

const AuthenticationPageTemplate = ({
  showBackNavigation = true,
  showLegalNotices = true,
  showWelcomeText = false,
  showLogo = false,
  skip2faPossible = false,
  title,
  instructions,
  children,
  onBackNavigation,
  alert,
}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const message = {
    color: alert?.color ?? 'error',
    text: alert?.text ?? location.state?.alert,
  }

  return (
    <>
      <Activity mode={showBackNavigation ? 'visible' : 'hidden'}>
        <Stack sx={{ flexDirection: 'row', gap: 2 }} displayPrint="none">
          <Button
            sx={{ gap: 2 }}
            color="neutral"
            onClick={() =>
              onBackNavigation ? onBackNavigation() : navigate(-1)
            }
          >
            <ArrowBackIcon sx={{ color: 'text.secondary' }}></ArrowBackIcon>
            Back
          </Button>
        </Stack>
      </Activity>

      <Stack sx={{ justifyContent: 'center', flexGrow: 1 }}>
        <Stack sx={{ p: 2, alignItems: 'center' }} spacing={4}>
          {message.text && (
            <Stack displayPrint="none">
              <Alert severity={message.color}>{message.text}</Alert>
            </Stack>
          )}

          <Activity mode={showLogo ? 'visible' : 'hidden'}>
            <Stack
              height={{ xs: '50px', md: '100px' }}
              width="100%"
              sx={{ alignItems: 'center' }}
            >
              <HolloidSvg sx={{ width: 'auto', height: '100%' }} />
            </Stack>
          </Activity>

          {showWelcomeText && (
            <Typography variant="h2" component="p" textAlign={'center'}>
              Welcome to Hollo Portal
            </Typography>
          )}

          <Typography variant="h4" component="h1" textAlign={'center'}>
            {title}
          </Typography>

          <Activity mode={instructions ? 'visible' : 'hidden'}>
            <Typography
              displayPrint="none"
              variant="body1"
              textAlign={'justify'}
            >
              {instructions}
            </Typography>
          </Activity>

          <Stack sx={{ width: { xs: '100%', sm: '85%', xl: '50%' } }}>
            {children}
          </Stack>
          {skip2faPossible && (
            <Link
              href={'/'}
              underline="hover"
              color="text.secondary"
              variant="body2"
            >
              Skip two-factor authentication setup
            </Link>
          )}
        </Stack>
      </Stack>

      <Activity mode={showLegalNotices ? 'visible' : 'hidden'}>
        <Grid
          container
          spacing={5}
          sx={{ justifyContent: 'center' }}
          displayPrint="none"
        >
          <Link
            href={privacyPageUrl}
            underline="hover"
            color="text.secondary"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ mt: 4 }}
          >
            Privacy Policy
          </Link>
          <Link
            href={contactPageUrl}
            underline="hover"
            color="text.secondary"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ mt: 4 }}
          >
            Contact
          </Link>
        </Grid>
      </Activity>
    </>
  )
}

export default AuthenticationPageTemplate
